/**
 * DEV-261 AC-75 — sem conexão a pessoa vê "Você está sem internet"
 * (20186:22985). O formulário fica montado por baixo: nada do que foi
 * preenchido se perde, e "Tentar novamente" só libera com a rede de volta.
 */
import { useEffect, useState, type ReactNode } from 'react';
import { NoConnectionScreen } from './SystemScreens';

export function ConnectionGate({ children }: { children: ReactNode }) {
  const [offline, setOffline] = useState(() => !navigator.onLine);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    window.addEventListener('offline', goOffline);
    return () => window.removeEventListener('offline', goOffline);
  }, []);

  return (
    <>
      {offline ? <NoConnectionScreen onRetry={() => setOffline(!navigator.onLine)} /> : null}
      <div hidden={offline} aria-hidden={offline || undefined}>
        {children}
      </div>
    </>
  );
}
